var _rect, _line, _line2, _rect2, _line3, _line4, _rect3, _line5, _line6, _rect4, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtTheClassics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 76,
    height: 16,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 20,
    x2: 46,
    y2: 36,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 20,
    x2: 70,
    y2: 36,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 76,
    height: 16,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 39,
    x2: 30,
    y2: 55,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 39,
    x2: 60,
    y2: 55,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 58,
    width: 76,
    height: 16,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 58,
    x2: 46,
    y2: 74,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 58,
    x2: 70,
    y2: 74,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 77,
    width: 76,
    height: 10,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 77,
    x2: 38,
    y2: 87,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 77,
    x2: 62,
    y2: 87,
    stroke: "#D28A60",
    strokeWidth: 2.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtTheClassics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-the-classics.282b816a53496e7b0c082833a83bbe7b.svg";